import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45bf5a34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "position-relative" }
const _hoisted_2 = { class: "row px-3 pt-1 pb-1" }
const _hoisted_3 = ["onMouseenter", "src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons small" }, "keyboard_arrow_left", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons small" }, "keyboard_arrow_right", -1))
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rendered, (color) => {
        return (_openBlock(), _createElementBlock("div", {
          key: color.id,
          class: "col-3 p-0"
        }, [
          _createVNode(_component_router_link, {
            to: '/product/' + _ctx.slug + '?color=' + color.id,
            class: "product-image-wrap position-relative d-block"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                onMouseenter: ($event: any) => (_ctx.updateThumb(color.thumb)),
                onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateThumb(_ctx.thumb))),
                alt: "Thumb color",
                class: "product-image position-absolute h-100 w-100",
                src: _ctx.theThumb(color.thumb)
              }, null, 40, _hoisted_3)
            ]),
            _: 2
          }, 1032, ["to"])
        ]))
      }), 128))
    ]),
    (this.start > 0)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.prev())),
          class: "d-flex pointer position-absolute prev"
        }, _hoisted_5))
      : _createCommentVNode("", true),
    (this.end < this.colors.length - 1)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.next())),
          class: "d-flex pointer position-absolute next"
        }, _hoisted_7))
      : _createCommentVNode("", true)
  ]))
}